import gql from 'graphql-tag';

export default gql`
  query appBannerQuery($id: ID!) {
    appImplementationById(id: $id) {
      id
      banner
    }
  }
`;
